import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";

import {
  getListOfCategoriesForCategoryViewUserQuery,
  getListOfAttachmentsByUserId,
  downloadAttachment,
  getListOfCategoriesSearchByName,
} from "../../services/graphql/queries/category-management";
import { getAccessPermisionQuery } from "../../services/graphql/queries/accessPermission";

import Pagination from "../MobileCommon/Pagination";
import NotAccessible from "../MobileCommon/NotAccessible";
import ReactModal from "../MobileCommon/ReactModal";

import {
  PAGINATION_OFFSET_VALUE,
  DO_NOT_ACCESS_MESSAGE,
  SET_TIMEOUT_VALUE,
} from "../../constants/app-constants";
import { errorMessage } from "../../miscellaneous/error-messages";

import DocumentFilter from "./DocumentFilter";

import downloadSvg from "../../static/images/download.svg";
import gridSvg from "../../static/images/grid.svg";
import { errorMsg, successMsg } from "../../miscellaneous/react-toastify";

const FileSaver = require("file-saver");
const mime = require("mime-types");

const INFO_UPLOAD_MODULE_ID = 7;
const INFO_UPLOAD_FEATURE_ID = 191;

class DocumentsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      pageOfItems: [],
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,

      categoryOption: [],
      showFilter: false,
      isFilterApply: false,
      filterData: {},
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: DO_NOT_ACCESS_MESSAGE,
      accessSpecifier: {},
      isSearch: false,
      isCategorySearch: true,
      searchValue: "",
    };
    this.submitModal = this.submitModal.bind(this);
    this.filterAction = this.filterAction.bind(this);
    this.onFilterData = this.onFilterData.bind(this);
  }

  submitModal() {
    this.setState({ reactModalVisible: false });
  }

  onAddDocument() {
    if (this.state.accessSpecifier.createP) {
      this.props.history.push("/info-add");
    } else {
      this.setState({ reactModalVisible: true });
    }
  }

  onFilterData(data, isFilterApply) {
    this.setState({
      isFilterApply: isFilterApply,
      filterData: data,
      currentPage: 1,
      isSearch: false,
      searchValue: "",
      pageOfItems: [],
    });
    if (isFilterApply) {
      this.getListOfCategory(this.state.offset, 1, data);
    } else {
      this.setState({
        filterData: {},
      });
      this.getListOfCategory(this.state.offset, 1);
    }
  }

  filterAction() {
    this.setState((prevState) => {
      return {
        showFilter: !prevState.showFilter,
      };
    });
  }

  onChangePage(currentPage) {
    // update state with new page of items
    this.setState(
      {
        currentPage: currentPage,
        loading: true,
      },
      () => {
        if (this.state.isFilterApply) {
          this.getListOfUsers(
            this.state.offset,
            currentPage,
            this.state.filterData
          );
        } else {
          this.getListOfCategory(this.state.offset, currentPage);
        }
      }
    );
  }

  getListOfCategory(offset, pageNo, data) {
    this.props.client
      .query({
        query: getListOfCategoriesForCategoryViewUserQuery,
        variables: {
          offset: offset,
          pageNo: pageNo,
          id: data && data.id ? data.id : null,
          name: data && data.name ? data.name : null,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var category = result.data.getListOfCategoriesForCategoryViewUser;

        for (let i = 0; i < category.length; i++) {
          category[i].isCategory = true;
          category[i].subcategoryLevel = 1;
        }

        this.initialState = {
          pageOfItems: category,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        this.setState({ loading: false, error: error.message });
      });
  }

  onSearchCategory() {
    var doc = document.querySelector("input[name=searchItem]:checked").value;
    if (doc == "Category") {
      if (this.state.searchValue != "") {
        this.setState({ isSearch: true, currentPage: 1, pageOfItems: [] });
        this.props.client
          .query({
            query: getListOfCategoriesSearchByName,
            variables: {
              name: this.state.searchValue,
            },
            fetchPolicy: "network-only",
          })
          .then((result) => {
            var category = result.data.getListOfCategoriesSearchByName;
            category = JSON.parse(category);
            const filteredCategory = category.filter(
              (item) => item.subcategoryLevel === 1
            );
            this.initialState = {
              pageOfItems: filteredCategory.length ? filteredCategory : [],
            };
            this.setState({ ...this.initialState, loading: false, error: "" });
          })
          .catch((error) => {
            this.setState({ loading: false, error: error.message });
          });
      }
    }
     else {
      if (this.state.searchValue != "") {
        this.setState({ isSearch: true, currentPage: 1, pageOfItems: [] });
        this.props.client
          .query({
            query: getListOfAttachmentsByUserId,
            variables: {
              offset: this.state.offset,
              pageNo: 1,
              tags: this.state.searchValue,
            },
            fetchPolicy: "network-only",
          })
          .then((result) => {
            var category = result.data.getListOfAttachmentsByUserId;
            this.initialState = {
              pageOfItems: category,
            };
            this.setState({ ...this.initialState, loading: false, error: "" });
          })
          .catch((error) => {
            this.setState({ loading: false, error: error.message });
          });
      }
    }
  }

  onClearSearch() {
    this.setState({
      isSearch: false,
      searchValue: "",
      pageOfItems: [],
      isCategorySearch: true,
    });
    this.getListOfCategory(this.state.offset, 1);
  }

  // onClickOfAttachment(attachment) {
  //   if (attachment.attachmentType == 1) {
  //     this.props.client
  //       .mutate({
  //         mutation: downloadAttachment,
  //         variables: {
  //           attachmentId: attachment.id,
  //         },
  //         fetchPolicy: "no-cache",
  //       })
  //       .then((result) => {
  //         let document = result.data.downloadSubCatAttachment;
  //         var byteCharacters = atob(document.fileData);

  //         var byteNumbers = new Array(byteCharacters.length);
  //         for (var i = 0; i < byteCharacters.length; i++) {
  //           byteNumbers[i] = byteCharacters.charCodeAt(i);
  //         }

  //         var byteArray = new Uint8Array(byteNumbers);

  //         const contentType = mime.lookup(document.fileName.split(".")[1]);

  //         var blob = new Blob([byteArray], {
  //           type: contentType,
  //         });

  //         FileSaver.saveAs(blob, document.fileName.substr(32));

  //         this.setState({
  //           errors: [],
  //           loading: false,
  //         });
  //       })
  //       .catch((error) => {
  //         console.log("~~~error: ", error);
  //         this.setState({ loading: false, errors: [errorMessage(error)] });
  //         this.timer = setTimeout(() => {
  //           this.setState({ errors: [] });
  //         }, SET_TIMEOUT_VALUE);
  //       });
  //   } else {
  //     let data = { GridId: attachment.gridId.id };
  //     localStorage.setItem("GridId-Input", JSON.stringify(data));
  //     // this.props.history.push("/grid-input-edit");
  //     // window.open("/grid-input-edit");
  //   }
  // }
  onClickOfAttachment(attachment) {
    if (attachment.attachmentType == 1) {
      this.setState((prevState) => ({
        downloadingAttachments: {
          ...prevState.downloadingAttachments,
          [attachment.id]: true, // Set only the clicked attachment as downloading
        },
        isDownloading:true
      }));
      // successMsg("Downloading File, please wait...");

      this.props.client
        .mutate({
          mutation: downloadAttachment,
          variables: {
            attachmentId: attachment.id,
          },
          fetchPolicy: "no-cache",
        })
        .then(async(result) => {
          let attachmentData = result.data.downloadSubCatAttachment;
          let presignedUrl = attachmentData?.fileData; // Get pre-signed URL
          let fileName = attachmentData?.fileName;

          if (!presignedUrl || !fileName) {
            console.error("Presigned URL or filename is missing!");
            this.setState({ isDownloading: false });
            return;
          }
    
          // Modify filename by removing the first 32 characters
          let modifiedFileName = fileName.length > 32 ? fileName.substr(32) : fileName;

          let link = document.createElement("a");
          link.href = presignedUrl;
          link.setAttribute("download", modifiedFileName); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          successMsg("Download Initiated");
          this.setState({
            errors: [],
            loading: false,
            isDownloading:false
          });
          this.setState((prevState) => ({
            downloadingAttachments: {
              ...prevState.downloadingAttachments,
              [attachment.id]: false, // Reset only the clicked attachment/download File
            },
          }));
        })
        .catch((error) => {
          console.log("~~~error in download: ", error);
          let message = errorMessage(error);
          errorMsg(message[0]);
          this.setState({
            loading: false,
            errors: [errorMessage(error)],
          });
          setTimeout(() => {
            this.setState({ isDownloading: false });
          }, 3000);
          this.setState((prevState) => ({
            downloadingAttachments: {
              ...prevState.downloadingAttachments,
              [attachment.id]: false, 
            },
          }));
          this.timer = setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    } else {
      let data = { GridId: attachment.gridId.id };
      localStorage.setItem("GridId-Input", JSON.stringify(data));
      // this.props.history.push("/grid-input-edit");
      // window.open("/grid-input-edit");
    }
  }
  getCategoryBreadcrumb(categoryStructure) {
    var name = "";
    categoryStructure = JSON.parse(categoryStructure);
    const arrayLength = categoryStructure.length;
    // var res = categoryStructure.map((data, index)=>{
    for (let i = 0; i < arrayLength; i++) {
      if (arrayLength === i + 1) {
        // last element
        name = name + categoryStructure[i];
      } else {
        // not last element
        name = name + categoryStructure[i] + " -> ";
      }
    }
    // })
    return name;
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });

    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: INFO_UPLOAD_MODULE_ID,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        this.setState({
          accessSpecifier: response[INFO_UPLOAD_FEATURE_ID],
        });
        this.getListOfCategory(this.state.offset, this.state.currentPage);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message,
        });
      });
  }

  render() {
    const {
      loading,
      error,
      accessSpecifier,
      reactModalVisible,
      requireCancel,
      modalMessage,
      pageOfItems,
      categoryOption,
      isSearch,
      isCategorySearch,
      searchValue,
    } = this.state;
    console.log("categoryOption",categoryOption)
    console.log("pageOfItems",pageOfItems)

    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>{error}</div>;
    }
    return (
      <>
        {accessSpecifier && accessSpecifier.viewP ? (
          <div>
            <ReactModal
              reactModalVisible={reactModalVisible}
              submitModal={this.submitModal}
              modalMessage={modalMessage}
              requireCancel={requireCancel}
            />

            <div className="main-heading task-list">
              <h1>Project List </h1>
              {/* <a
                className="filter-popover"
                data-html="true"
                data-placement="auto"
                onClick={() => {
                  this.filterAction();
                }}
              >
                <i class="fas fa-filter fa-2x white"></i>
              </a> */}
            </div>

            {this.state.showFilter ? (
              <DocumentFilter
                showFilter={this.state.showFilter}
                filterData={this.state.filterData}
                listData={this.onFilterData}
                filterAction={this.filterAction}
                categoryOption={categoryOption}
              />
            ) : null}

            <section class="main-section pt-0 pl-0 pr-0">
              <div className="search-field">
                <input
                  type="text"
                  id="search"
                  style={{ width: "50%" }}
                  placeholder="Search"
                  value={searchValue}
                  onChange={(e) =>
                    this.setState({ searchValue: e.target.value })
                  }
                />
                <button
                  className="btn btn-danger m-l-10"
                  onClick={() => this.onSearchCategory()}
                >
                  Go
                </button>
                <button
                  className="btn btn-light m-l-10"
                  onClick={() => this.onClearSearch()}
                >
                  Clear
                </button>
              </div>
              <div
                className="row"
                style={{ padding: "0 10px", margin: "10px 0 0 0" }}
              >
                <div className="col-md-6" style={{ width: "50%" }}>
                  <input
                    type="radio"
                    name="searchItem"
                    value="Category"
                    checked={isCategorySearch}
                    style={{ margin: "5px" }}
                    onClick={(e) => {
                      this.setState({
                        isCategorySearch: true,
                        pageOfItems: [],
                        searchValue: "",
                      });
                      this.getListOfCategory(this.state.offset,1)
                    }}
                  />
                  <label for="Category">Project</label>
                </div>
                <div className="col-md-6" style={{ width: "50%" }}>
                  <input
                    type="radio"
                    name="searchItem"
                    value="Document"
                    checked={!isCategorySearch}
                    style={{ margin: "5px" }}
                    onClick={(e) => {
                      this.setState({
                        isCategorySearch: false,
                        pageOfItems: [],
                        searchValue: "",
                      });
                    }}
                  />
                  <label for="Document">Document</label>
                </div>
              </div>
              <div className="table-responsive">
                {isSearch && !isCategorySearch ? (
                  <table className="table table-style-1">
                    <thead>
                      <tr>
                        <th scope="col" className="text-left">
                          PROJECTS
                        </th>
                        <th scope="col">TYPE</th>
                        <th scope="col">NAME</th>
                        <th>DESCRIPTION</th>
                        <th>ACTION(s)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pageOfItems.length
                        ? pageOfItems.map((data, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  {this.getCategoryBreadcrumb(
                                    data.categoryStructure
                                  )}
                                </td>
                                <td>
                                  {data.attachmentType == 1
                                    ? "Document"
                                    : "Grid"}
                                </td>
                                <td>{data.name}</td>
                                <td>{data.description}</td>
                                <td>
                                  {data.attachmentType == 2 ? (
                                    <a
                                      className="link-click"
                                      href={"/mobile-grid-input"}
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="Go To Grid"
                                      onClick={() => {
                                        localStorage.setItem(
                                          "breadCrumb",
                                          JSON.stringify([])
                                        );
                                        this.onClickOfAttachment(data);
                                      }}
                                    >
                                      <img src={gridSvg} alt="" />
                                    </a>
                                  ) : (
                                    <a
                                      className="link-click"
                                      href="#"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="Download"
                                      onClick={() =>
                                        this.onClickOfAttachment(data)
                                      }
                                    >
                                      <img
                                        src={downloadSvg}
                                        alt=""
                                        width="16"
                                      />
                                    </a>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </table>
                ) : (
                  <table className="table table-style-1">
                    <thead>
                      <tr>
                        <th scope="col" className="text-left">
                          ID
                        </th>
                        <th scope="col">NAME</th>
                        <th scope="col">DESCRIPTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pageOfItems.length
                        ? pageOfItems.map((data, index) => {
                            return (
                              <tr
                                key={index}
                                onClick={() => {
                                  let arr = [];
                                  arr.push(data);
                                  localStorage.setItem(
                                    "breadCrumb",
                                    JSON.stringify(arr)
                                  );
                                  localStorage.setItem(
                                    "categoryId",
                                    JSON.stringify(data)
                                  );
                                  this.props.history.push(
                                    "/mobile-view-info-detail"
                                  );
                                }}
                              >
                                <td>{data.id}</td>
                                <td>{data.name}</td>
                                <td>{data.description}</td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </table>
                )}
              </div>

              {!pageOfItems.length && error ? <div>{error}</div> : null}
              {!pageOfItems.length && loading ? <div>Fetching...</div> : null}
              {!pageOfItems.length && !error && !loading ? (
                <div style={{ textAlign: "center" }}>No Data</div>
              ) : null}
              {/* <Pagination
                loading={loading}
                items={pageOfItems}
                pageSize={this.state.offset}
                initialPage={this.state.currentPage}
                onChangePage={this.onChangePage.bind(this)}
              /> */}
            </section>
          </div>
        ) : (
          <NotAccessible />
        )}
      </>
    );
  }
}
export default withRouter(withApollo(DocumentsList));
